<template>
  <div
     class="nuttrema-dot-kcal"
    :class="[className.kcal]"
    :title="title">
    <el-tooltip :content="$t(label, { kcal: enercKcal, grams })" placement="right" effect="dark">
      <span class="dot"></span>
    </el-tooltip>
  </div>
</template>

<script>
import NuttremaIconicaKcal from './nuttrema-iconica-kcal';

export default {
  name: 'nuttrema-dot-kcal',
  mixins: [NuttremaIconicaKcal],
  props: {
    label: {
      required: false,
      default: 'label.kcal_per_gram_ingredients_quantity',
    },
    grams: {
      required: false,
      default: 100,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/label/nuttrema-dot-kcal.vue